export const CREATING_MENUTYPE = "CREATING_MENUTYPE";
export const UPDATING_MENUTYPE = "UPDATING_MENUTYPE";
export const MENUTYPE_CREATED = "MENUTYPE_CREATED";
export const MENUTYPE_UPDATED = "MENUTYPE_UPDATED";
export const ERROR_MENUTYPE_CREATE = "ERROR_MENUTYPE_CREATE";
export const ERROR_MENUTYPE_UPDATE = "ERROR_MENUTYPE_UPDATE";
export const UPDATED_RECENTLY = "UPDATED_RECENTLY";
export const SET_UPDATED_RECENTLY_TO_FALSE = "SET_UPDATED_RECENTLY_TO_FALSE";
